import { render } from "./VocationalHowOpen.vue?vue&type=template&id=07e65822&scoped=true"
import script from "./VocationalHowOpen.vue?vue&type=script&lang=js"
export * from "./VocationalHowOpen.vue?vue&type=script&lang=js"

import "./VocationalHowOpen.vue?vue&type=style&index=0&id=07e65822&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e65822"]])

export default __exports__